var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdownArrowBold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 443.5 443.5",
    style: {
      enableBackground: "new 0 0 443.5 443.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.2,364c-7.3,0-14.2-2.9-19.5-8.1L7.7,160.8c-10.5-11-10.2-28.4,0.7-38.8c5.1-4.9,11.9-7.7,19.1-7.7 c7.2,0,14,2.7,19.1,7.7l175.7,175.6l175.5-175.5c5.2-5.2,12.1-8.1,19.5-8.1c7.4,0,14.3,2.9,19.4,8.1c5.2,5.2,8,12.1,8,19.5 c0,7.3-2.9,14.2-8.1,19.3L241.6,355.9C236.5,361.1,229.6,364,222.2,364z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7,348L15.8,153c-6.2-6.5-6.1-16.8,0.4-22.9c6.3-6.1,16.3-6.1,22.6,0l183.5,183.4l183.4-183.4 c6.4-6.4,16.7-6.4,22.9,0c6.4,6.4,6.4,16.7,0,22.9L233.7,348C227.4,354.3,217.1,354.3,210.7,348z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowBold);
export default __webpack_public_path__ + "static/media/dropdown_arrow_bold.e802193ce40fb773f2ca60db66643698.svg";
export { ForwardRef as ReactComponent };